<template>
  <v-card
    flat
    class="grey lighten-4 rounded-lg"
    >
    <v-card-title>
      Pagos parciales
    </v-card-title>

    <v-card-text
      class="text--primary"
      >
      <div
        v-if="payment.children && payment.children.length"
        >
        <v-row>
          <v-col
            cols="2"
            class="body-1 py-2"
            >
          </v-col>

          <v-col
            cols="10"
            class="text-right py-2"
            >
            Monto
          </v-col>
        </v-row>

        <template
          v-for="(child, i) in payment.children"
          >
          <v-row
            :class="i % 2 ? 'grey lighten-4' : 'white'"
            >
            <v-col
              cols="2"
              class="body-1"
              >
              <v-btn
                icon
                small
                color="error"
                @click="deletePartialPayment(child.id)"
                >
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-btn>
            </v-col>

            <v-col
              cols="10"
              class="body-1 text-right font-weight-medium"
              >
              {{ price(child.amount) }}
            </v-col>
          </v-row>
        </template>

        <div
          class="text-right text-h6 font-weight-medium mt-2"
          >
          {{ price(payment.lastingAmount) }}
        </div>
      </div>

      <v-card
        outlined
        class="rounded-lg"
        v-else
        >
        <v-card-text
          class="text--primary"
          >
          No hay pagos parciales.
        </v-card-text>
      </v-card>

      <div
        class="text-right d-flex flex-row mt-3"
        >
        <v-text-field
          solo
          outlined
          flat
          hide-details="auto"
          dense
          v-model="amount"
          label="Monto pago parcial"
          class="rounded-l-lg rounded-r-0"
          :rules="[
            v => Math.abs(v) <= Math.abs(payment.lastingAmount) || `El valor debe ser menor o igual a ${Math.abs(payment.lastingAmount)}`
          ]"
          ></v-text-field>

        <v-btn 
          color="primary"
          primary
          height="40"
          class="rounded-r-lg rounded-l-0"
          style="margin-left: -1px"
          :disabled="!amount || loading"
          :loading="loading"
          @click="partialPay"
          >
          Añadir
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { DeletePartialPayment, PartialPay } from '@/graphql/mutations/payments'

export default {
  data: () => ({
    amount: null,
    loading: false
  }),

  props: {
    payment: {
      required: true,
      type: Object
    },

    receiptType: {
      required: true,
      type: String
    }
  },

  methods: {
    partialPay () {
      this.loading = true

      this.$apollo.mutate({
        mutation: PartialPay,
        variables: {
          input: {
            paymentId: this.payment.id,
            value: this.amount,
            receiptType: this.receiptType
          }
        }
      }).then(res => {
        this.loading = false
        this.$emit('reload')
      })
    },

    deletePartialPayment (id) {
      this.loading = true

      this.$apollo.mutate({
        mutation: DeletePartialPayment,
        variables: {
          input: {
            partialPaymentId: id
          }
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        this.loading = false
        this.amount = null
        this.$emit('reload')
      })
    },

    price (amount) {
      const options = { style: 'currency', currency: 'ARS' };
      const numberFormat = new Intl.NumberFormat('es-AR', options);

      return numberFormat.format(Math.abs(amount))
    },

    reload () {
      this.$emit('reload')
    }
  }
}
</script>
